<template>
	<div class="container about">
		<div class="row head">
			<div class="col">
				<h1>O nas</h1>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi consequatur consequuntur dignissimos distinctio dolor dolorem enim ex in laudantium nihil obcaecati odio placeat, quibusdam ratione rem repellat tenetur totam voluptatem.Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi consequatur consequuntur dignissimos distinctio dolor dolorem enim ex in laudantium nihil obcaecati odio placeat, quibusdam ratione rem repellat tenetur totam voluptatem.Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi consequatur consequuntur dignissimos distinctio dolor dolorem enim ex in laudantium nihil obcaecati odio placeat, quibusdam ratione rem repellat tenetur totam voluptatem.
				</p>
			</div>
		</div>
		<hr>
		<div class="row head">
			<div class="col-lg-12">
				<h1>Nasz zespół</h1>
			</div>
		</div>
		<div class="row">
			<div v-for="person in team" class="col-lg-4 col-md-4 col-sm-6 about">
				<img :src="person.img" :alt="person.name" class="rounded-circle head-image" width="180" height="180">
				<h2>{{person.name}}</h2>
			</div>
		</div>
	</div>
</template>

<script>
	import head1 from './../assets/Entypo+/user.svg';

	export default {
		data() {
			return {
				team: [
					{name: 'Marcin Barczewski', img: head1},
					{name: 'Karol Michalski', img: head1},
					{name: 'Mateusz Przybylski', img: head1}
				]
			};
		}
	};
</script>

<style>
	.about {
		text-align: center;
		padding-top: 30px;
	}

	.head {
		padding-top: 30px;
		text-align: left;
		color: black;
	}

	.head-image {
		margin: 25px 0;
	}
</style>
